import React, { lazy, Suspense } from 'react';
import { createBrowserRouter, Route, createRoutesFromElements, Navigate, Outlet } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import { GradingHistoryProvider } from './pages/EmbryoGradingAI/GradingHistoryContext';
import NoLayout from './layouts/NoLayout';
import DefaultLoader from './components/defaultLoader';
import InventoryLoader from './components/defaultLoader/InventoryLoader';
import { CalendarPage } from './pages/calendarPage';
import CalendarLoader from './components/calendarComponent/calanderLoader';
import InvestigationDiag from './pages/Clinical_Profile/Investigation_Diagnosis/Investigation_diagnosis.index';
import TreatmentPlanPage from './pages/TreatmentPlanPage';
import SurgeryPage from './pages/Surgery';
import CycleOverview from './pages/CycleOverview/CycleOverview';
import StimPage from './pages/Stim';
import Andrology from './pages/Andrology/Andrology';
import { RedirectLogin } from './pages/login/index';
import EmbryoCulture from './pages/Embryology/Embryo_Culture/embryoCulture';
import OocyteCryoStrorage from './pages/cryoStorage/oocyteCryo/oocyteCryoStrorage';
import EmbryoStorage from './pages/cryoStorage/embryoCryo/EmbryoStorage';
import SpermStorage from './pages/cryoStorage/spermCryo/spermStorage';
import NotFoundPage from './pages/notFoundPage';
import PgtHome from './components/pgt/pgtHome';
import PgtHome2 from './components/pgt/PgtHome2';
import UserConfig from './pages/Configuration/User/UserConfig';
import AddUser from './pages/Configuration/User/UserDetails/AddUser';
import ClinicConfig from './pages/Configuration/Clinic/clinicConfig';
import PageConfig from './pages/Configuration/PageConfig/pageConfig';
import ClinicAddEditInfoForm from './components/ClinicConfiguration/ClinicAddEditInfoForm';
import { useTranslation } from 'react-i18next';
import { RouterProvider } from 'react-router-dom';
import Barchart from './pages/KPI_Dashboard/barChart';
import Piechart from './pages/KPI_Dashboard/Piechart';
import PolarAreaChart from './pages/KPI_Dashboard/PolarAreaChart';
import LineChart from './pages/KPI_Dashboard/LineChart';
import RadarChart from './pages/KPI_Dashboard/RadarChart';
import DonutChart from './pages/KPI_Dashboard/DonutChart';
import KPIDashboard from './pages/KPI_Dashboard/KPIdashboard.index';
import AimbryoDetails from './pages/Embryology/Embryo_Culture/AimbryoDetails';
import Billing from './pages/Billing/Billing';
import PackageList from './pages/Configuration/Package/PackageList';
import PackageConfigDetails from './pages/Configuration/Package/PackageConfigDetails';
import InventoryApprovalList from './pages/Configuration/InventoryApproval/InventoryApprovalList';
import CreateApprovalRule from './pages/Configuration/InventoryApproval/CreateApprovalRule/CreateApprovalRule';
import ViewApprovalRule from './pages/Configuration/InventoryApproval/ViewApprovalRule/ViewApprovalRule';
import PakageDetails from './pages/Billing/Package/PackageDetails/PackageDetails';
import Package from './pages/Billing/Package/Package';
import Invoice from './pages/Billing/Invoice/Invoice';
import Advance from './pages/Billing/Advance/Advance';
import Refund from './pages/Billing/Refund/Refund';
import InvoicePatientSelector from './pages/Billing/Invoice/InvoicePatientSelector';
// import NewInvoicePage from './pages/Billing/Invoice/NewInvoicePage';
// import NewInvoicePage from './pages/Billing/Invoice/NewInvoicePage';
// import PackageDefinition from './pages/Configuration/Package/PackageDefinition';
import ViewInvoice from './pages/Billing/Invoice/newInvoice/ViewInvoice';
import CombinedInvoicePage from './pages/Billing/Invoice/newInvoice/CombinedInvoicePage';
import CollectAdvance from './pages/Billing/Advance/Advance_Request/collectAdvance';
import RequestRefund from './pages/Billing/Advance/Recieved_Advance/RequestRefund';
import CheckedInPage from './pages/Billing/Advance/CheckedIn_Advance/CheckedInPage';
import AdvanceLogs from './pages/Billing/Advance/AdvanceLogs';
import InvoiceLogs from './pages/Billing/Invoice/InvoiceLogs/InvoiceLogs';
import AdvanceRefundDetails from './pages/Billing/Refund/RefundDetails/Advance/Advance_Refund';
import InvoiceRefundDetails from './pages/Billing/Refund/RefundDetails/Invoice/InvoiceDetails';
import RefundDetails from './pages/Billing/Refund/RefundDetails/RefundDetails';
import PatientInvoiceLogs from './pages/Billing/Invoice/InvoiceLogs/PatientInvoiceLogs';
import ReceiveListPage from './pages/Inventory/StockTransfer/Receive/ReceiveListPage';
import Pharmacy from './pages/Billing/Pharmacy/Pharmacy';
import PharmacyPatientSelector from './pages/Billing/Pharmacy/PharmacyPatientSelector';
import NewPatientInvoice from './pages/Billing/Pharmacy/NewPatientPharmacy/NewPatientInvoice';
import NewPharmacyPage from './pages/Billing/Pharmacy/NewPharmacyPage';
import ViewPharmacyInvoice from './pages/Billing/Pharmacy/ViewPharmacyInvoice';
import PharmacyInvoiceLogs from './pages/Billing/Pharmacy/PharmacyInvoiceLogs/PharmacyInvoiceLogs';
import PatientPackageList from './pages/Billing/Package/PatientPackageList';
import PatientAdvance from './pages/Billing/Advance/PatientAdvance';
import PatientRefund from './pages/Billing/Refund/PatientRefund';
import PatientInvoice from './pages/Billing/Invoice/PatientInvoice';
import PatientPharmacy from './pages/Billing/Pharmacy/PatientPharmcy';
import PharmacyDispense from './pages/pharmacy-dispense/PharmacyDispense';
import DirectPharmacyDispense from './pages/pharmacy-dispense/DirectPharmacyDispense';

import { isAuthenticated, clearAuthData } from './utils/authUtils';
import { PatientSalesReturnList } from './pages/Return/Sales/PatientSalesReturnList';
import DocumentIntPatientList from './pages/Ai_Hub/DocumentIntelligence/DocumentIntPatientList';
import DocumentIntelligencePatientDetail from './pages/Ai_Hub/DocumentIntelligence/DocumentIntelligencePatientDetail';
import AIVoiceExtractionReview from './pages/Ai_Hub/VoiceDataEntry/AIVoiceExtractionReview';
import AIVoiceExtractionResult from './pages/Ai_Hub/VoiceDataEntry/AIVoiceExtractionResult';

// Lazy loading components
const Examination = lazy(() => import('./pages/Clinical_Profile/Examination/Examination'));
const Login = lazy(() => import('./pages/login/index'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword/ForgotPassword'));
const HPI = lazy(() => import('./pages/Clinical_Profile/HPI/Hpi'));
const RegistrationPage = lazy(() => import('./pages/Registration/index'));
const NewRegistrationPage = lazy(() => import('./pages/Registration/NewRegistration/index'));
const PatientPartnerRegistrationPage = lazy(() => import('./pages/Registration/NewRegistration/PatientPartnerRegistration/index'));
const BillingInformationPage = lazy(() => import('./pages/Registration/NewRegistration/BillingInformation/index'));
const PatinetView = lazy(() => import('./pages/patientView/index'));
const ClinicalPatientList = lazy(() => import('./pages/Clinical_Profile/patinetProfile.index'));
const MedicalHistory = lazy(() => import('./pages/Clinical_Profile/MedicalHistory/medicaHistory.index'));
const StockTransferContainer = lazy(() => import('./pages/Inventory/StockTransfer/stockTransferContainer'));
const IdentListPage = lazy(() => import('./pages/Inventory/StockTransfer/Indent/IdentListPage'));
const IssueListPage = lazy(() => import('./pages/Inventory/StockTransfer/Issue/IssueListPage'));
const SemenThawing = lazy(() => import('./pages/SemenThawing/SemenThawing'));
const PurchaseViewPage = lazy(()=> import ('./pages/Purchase/index'));
const RequisitionViewPage =lazy(()=>import('./pages/Purchase/Requisition/index'));
const NewRequisition =lazy(()=>import('./pages/Purchase/Requisition/New'));
const EditRequisition =lazy(()=>import('./pages/Purchase/Requisition/Edit'));
const NewPurchaseOrder =lazy(()=>import('./pages/Purchase/PurchaseOrder/New'));
const EditPurchaseOrder =lazy(()=>import('./pages/Purchase/PurchaseOrder/Edit'));
const ViewPurchaseOrder =lazy(()=>import('./pages/Purchase/PurchaseOrder/View'));
const PurchaseOrderPerspectiveList =lazy(()=>import('./pages/Purchase/PurchaseOrder/Prospective/index'));
const PurchaseOrderOrderedList =lazy(()=>import('./pages/Purchase/PurchaseOrder/Ordered/index'));
const EmbryoPatientList =lazy(()=>import('./pages/Embryology/patientList'));
const OocyteGrading =lazy(()=>import('./pages/Embryology/Occyte-Grading/occyteGrading.index'));
const SemenAnalysisDetails =lazy(()=>import('./pages/SemenAnalysis/SemenAnalysisDetails'));
const Collectiondetails =lazy(()=>import('./components/SemanAnalysisComponent/SemanAnalysisComponent'));
const ReturnViewPage = lazy(()=>import('./pages/Return/index'));
const NewSalesReturnPage = lazy(() => import('./pages/Return/Sales/NewSalesReturn'));
const SemenFreezing = lazy(()=>import('./pages/SemenFreezing/SemenFreezing'));
const SemenProcessing =lazy(()=>import('./pages/SemenProcessing/SemenProcessing'));
const CryoThawing =lazy(()=>import('./pages/CryoThawing/CryoThawing'));
const SemenIUI =lazy(()=>import('./pages/SemenIUI/SemenIUI'));
const PatientAppointment = lazy(()=>import('./components/AppointmentTable/patientAppointment'));
const Summary = lazy(()=>import('./components/MedicalHistorySummary/MedicalHistorySummary'));
const OutcomePage = lazy(()=>import('./pages/Outcome/Outcome'));
const ClinicalDashboard = lazy(()=>import('./pages/Dashboard/Clinical_Dashboard/ClinicalDashboard'));
const LabDashboard = lazy(()=>import('./pages/Dashboard/Lab_Dashboard/LabDashboard'));
const Documents = lazy(()=>import('./pages/Patient-Documents/Documents.Index'));
const ConsentConfigContainer = lazy(()=> import('./pages/Configuration/Consents/consentConfig'));
const ConsentAddEdit =lazy(()=> import('./pages/Configuration/Consents/Consent'));
const AdminReports =lazy(()=> import('./pages/MIS_Reports/Admin/AdminReports'));
const ReportTable =lazy(()=> import('./pages/MIS_Reports/ReportTable'));
const CimaPatientList = lazy(() => import('./pages/CIMA/index'));
const ReferaMDPatientList = lazy(() => import('./pages/ReferaMD/index'));
const EmbryoGradingAI = lazy(() => import('./pages/EmbryoGradingAI/EmbryoGradingAI'));
const EmbryoGradingAIHub = lazy(() => import('./pages/Ai_Hub/EmbryoGradingAI'));
const AIVoiceChatBot = lazy(() => import('./pages/Ai_Hub/VoiceDataEntry/AIVoiceChatBot'));
const EmbryoGradeAssistantPage = lazy(() => import('./pages/Ai_Hub/EmbryoGradeAssistant'));
const EmbryoGraderPatientListComponent = lazy(() => import('./pages/Ai_Hub/EmbryoGraderPatientListComponent'));
const EmbryoGradeLivebirthprediction = lazy(() => import('./pages/Ai_Hub/EmbryoGradeLivebirthprediction'));
const EmbryoGradeLivebirthpredictionDetail = lazy(() => import('./pages/Ai_Hub/EmbryoGradeLivebirthpredictionDetail'));
const AiVoiceDataEntry = lazy(() => import('./pages/Ai_Hub/VoiceDataEntry/AIVoiceDataEntry'));
const AILeadChatbotPatientList = lazy(() => import('./pages/Ai_Hub/AILeadChatbotPatientList'));
const AIAssistant = lazy(() => import('./pages/Ai_Hub/AIAssistant'));
const RFIDMainComponent =lazy(()=>import('./pages/RFID/RFIDMainComponent'));
const RFIDDashboard = lazy(() => import('./pages/RFID/RFIDDashboard'));

const StockContainer = lazy(() => import('./pages/Inventory/Stocks/stockContainer'));
const AvailableStock = lazy(() => import('./pages/Inventory/Stocks/AvailableStock'));
const MaterialConsumptionLog = lazy(() => import('./pages/Inventory/MaterialConsumption/MaterialConsumptionLog'));

const GRNContainer = lazy(() => import('./pages/Inventory/GRN/GRNContainer'));
const GrnProspective = lazy(() => import('./pages/Inventory/GRN/Prospective/GrnProspective'));
const GrnReceived = lazy(() => import('./pages/Inventory/GRN/Received/GrnReceived'));
const QuantityAdjustmentIndex = lazy(() => import('./pages/Inventory/StockAdjustment/QuantityAdjustment'));
const StockAdjustmentContainer = lazy(() => import('./pages/Inventory/StockAdjustment/stockAdjustmentContainer'));
const CostAdjustmentListPage = lazy(() => import('./pages/Inventory/StockAdjustment/CostMRPAdjustment/CostAdjustmentListPage'));
const BatchExpiryAdjustmentIndex = lazy(() => import('./pages/Inventory/StockAdjustment/BatchExpiryAdjustment/index'));

const EmbryologyCopilot = lazy(() => import('./pages/Ai_Hub/EmbryologyCopilot'));
const FinanceBot = lazy(() => import('./pages/Ai_Hub/FinanceBot'));
/**
 * PublicRoute component - protects routes that should only be accessible when NOT authenticated
 * Redirects authenticated users to the main app
 */
const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  if (isAuthenticated()) {
    return <Navigate to="/admin/appointments" replace />;
  }
  
  // Clear any invalid/expired auth data when not authenticated
  const token = localStorage.getItem('token') || sessionStorage.getItem('token');
  if (token) {
    clearAuthData();
  }
  
  return <>{children}</>;
};

function AppRouterWithI18n() {
  const { t: tTopBar } = useTranslation('topbar_config');
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path='/lab-dashboard'
          element={
            <Suspense fallback={<DefaultLoader />}>
              <LabDashboard />
            </Suspense>
          }
        />
        <Route path='/' element={<Navigate to='/login' replace />} />
        {/* Public Route for Login */}
        <Route
          path='/login'
          element={
            <Suspense fallback={<DefaultLoader />}>
              <PublicRoute>
                <NoLayout>
                  <Login />
                </NoLayout>
              </PublicRoute>
            </Suspense>
          }
        />

        <Route
          path='/forgot-password'
          element={
            <Suspense fallback={<DefaultLoader />}>
              <PublicRoute>
                <NoLayout>
                  <ForgotPassword />
                </NoLayout>
              </PublicRoute>
            </Suspense>
          }
        />

        {/* Main Routes with Layout */}
        <Route
          path='/'
          element={<MainLayout />} // MainLayout wraps routes with header and sidebar
        >
          {/* Admin Routes */}
          <Route
            path='admin'
            handle={{ breadcrumb: tTopBar('breadcrum.admin') }}
            hasErrorBoundary
          >
            <Route index element={<Navigate to='appointments/' replace />} />

            <Route
              path='appointments/'
              element={
                <Suspense fallback={<CalendarLoader />}>
                  <CalendarPage />
                </Suspense>
              }
              handle={{ breadcrumb: tTopBar('breadcrum.appointments') }}
            />
            <Route
              path='appointments/patient/:id'
              element={
                <Suspense fallback={<CalendarLoader />}>
                  <PatientAppointment />
                </Suspense>
              }
              handle={{ breadcrumb: tTopBar('breadcrum.appointments') }}
            />
            <Route
              path='registration/'
              handle={{ breadcrumb:  tTopBar('breadcrum.registration') }}
            >
              <Route
                index
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <RegistrationPage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
              <Route
                path='patient/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PatinetView />
                  </Suspense>
                }
                handle={{ breadcrumb: ({ id }: { id: string }) => `Patient #${id}` }}
              />
              <Route
                path='patient-list'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <RegistrationPage />
                  </Suspense>
                }
                handle={{ breadcrumb:  tTopBar('breadcrum.patient_list') }}
              />
              <Route
                path='new-registration'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <NewRegistrationPage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.new_registration') }}
              />
              <Route
                path='patient-partner-registration'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PatientPartnerRegistrationPage />
                  </Suspense>
                }
                handle={{ breadcrumb:  tTopBar('breadcrum.new_registration') }}
              />
              <Route
                path='patient-partner-registration-update'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PatientPartnerRegistrationPage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.update_patient') }}
              />
              <Route
                path='billing-information'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <BillingInformationPage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.billing_information') }}
              />
            </Route>

            {/* CIMA Routes */}
            <Route
              path='cima'
              handle={{ breadcrumb: tTopBar('breadcrum.cima') }}
            >
              <Route index element={<Navigate to='patient-list' replace />} />
              <Route
                path='patient-list'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <CimaPatientList />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
            </Route>
            
            {/* Refera MD Route */}
            <Route
              path='refera'
              handle={{ breadcrumb: tTopBar('breadcrum.refera_md') }}
            >
              <Route index element={<Navigate to='patient-list' replace />} />
              <Route
                path='patient-list'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <ReferaMDPatientList />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
            </Route>

            {/* Vidai Leads Route */}
            <Route
              path='vidai-leads'
              handle={{ breadcrumb: tTopBar('breadcrum.vidai_leads') }}
            >
              <Route index element={<Navigate to='patient-list' replace />} />
              <Route
                path='patient-list'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <CimaPatientList />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
            </Route>
            <Route
              path='pharmacy-dispense'
              handle={{ breadcrumb: tTopBar('breadcrum.pharmacy_dispense') }}
            >
              <Route
                index
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PharmacyDispense />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
              {/* <Route
                path='prescribed-list/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PrescribedListForPharmacyDispanse />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.prescribed_list') }}
              />

              <Route
                path='new/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <NewPharmacyDispanse />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.new_pharmacy_dispense') }}
              /> */}

              <Route
                path='new/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <DirectPharmacyDispense />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.new_pharmacy_dispense') }}
              />
            </Route>

            <Route

              path='billing'
              handle={{ breadcrumb: tTopBar('breadcrum.billing') }}
              element={
                <Suspense fallback={<DefaultLoader />}>
                  <Billing />
                </Suspense>
              }
            >
              {/* Default /billing -> /billing/package */}
              <Route index element={<Navigate to='package' replace />} />
              
              <Route
                path='package'
                handle={{ breadcrumb: tTopBar('breadcrum.package') }}
              >
                <Route
                  index
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <Package />
                    </Suspense>
                  }
                />

                <Route
                  path='patient-package/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PatientPackageList />
                    </Suspense>
                  }
                />
              </Route>

              {/* <Route
                path='invoice'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <Invoice />
                  </Suspense>
                }
                handle={{ breadcrumb: 'Invoice' }}
              >
                <Route
                  path='new'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <InvoicePatientSelector />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.new_invoice', { defaultValue: 'New Invoice' }) }}
                />
              </Route> */}

              <Route
                path='invoice'
                handle={{ breadcrumb: tTopBar('breadcrum.invoice') }}>
                <Route
                  index
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <Invoice />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
                />
                
                <Route
                  path='new'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <InvoicePatientSelector />
                    </Suspense>
                  }
                  handle={{ breadcrumb: 'New Invoice' }}
                />  


                <Route
                  path='view/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <ViewInvoice />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.view_invoice', { defaultValue: 'View Invoice' }) }}
                />  

                

                
                {/* <Route
                  path='new/:id'
                  element={
                    <Suspense fallback={<CalendarLoader />}>
                      <NewInvoicePage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('New Invoice') }}
                /> */}

                <Route
                  path='new/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <CombinedInvoicePage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.new_invoice', { defaultValue: 'New Invoice' }) }}
                />

                <Route
                  path='log/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <InvoiceLogs />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.invoice_logs', { defaultValue: 'Invoice Logs' }) }}
                />

                <Route
                  path='patient-log/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PatientInvoiceLogs />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.patient_logs', { defaultValue: 'Patient Logs' }) }}
                />

                <Route
                  path='patient-invoice/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PatientInvoice />
                    </Suspense>
                  }
                />

              </Route>


              <Route
                path='pharmacy'
                handle={{ breadcrumb: tTopBar('breadcrum.pharmacy') }}>
                <Route
                  index
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <Pharmacy />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
                />
                
                <Route
                  path='new'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PharmacyPatientSelector />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.new_pharmacy', { defaultValue: 'New Pharmacy' }) }}
                />  

                <Route
                  path='new-pharmacy-details/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <NewPatientInvoice />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.new_pharmacy_details', { defaultValue: 'New Pharmacy Details' }) }}
                />
                
                <Route
                  path='new/:id'
                  element={
                    <Suspense fallback={<CalendarLoader />}>
                      <NewPharmacyPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('New Invoice') }}
                />    



                <Route
                  path='view/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <ViewPharmacyInvoice />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.view_pharmacy_invoice', { defaultValue: 'View Pharmacy Invoice' }) }}
                />  

                <Route
                  path='logs/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PharmacyInvoiceLogs />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.invoice_logs', { defaultValue: 'Invoice Logs' }) }}
                />  

                <Route
                  path='patient-pharmacy/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PatientPharmacy />
                    </Suspense>
                  }
                />  

              </Route>

              <Route
                path="advance"
                handle={{ breadcrumb: tTopBar('breadcrum.advance') }}
              >
                <Route index element={<Navigate to="advance-list" replace />} />
                <Route
                  path="advance-list"
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <Advance />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.advance_list', { defaultValue: 'Advance List' }) }}
                />
                <Route
                  path="checked-in/:id/:appointment_id"
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <CheckedInPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.checked_in', { defaultValue: 'Checked In' }) }}
                />
                <Route
                  path="collect-advance/:id"
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <CollectAdvance />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.collect_advance', { defaultValue: 'Collect Advance' }) }}
                />
                <Route
                  path="request-refund/:id"
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <RequestRefund />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.request_refund', { defaultValue: 'Request Refund' }) }}
                />
                <Route
                  path="advance-logs/:id"
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <AdvanceLogs />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.advance_logs', { defaultValue: 'Advance Logs' }) }}
                />
                <Route 
                  path='patient-advance/:id'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PatientAdvance />
                    </Suspense>
                  }
                />
              </Route>
              

              <Route
                path='refund'
               
                handle={{ breadcrumb: tTopBar('breadcrum.refund') }}
              >
                <Route index element={<Navigate to="refund-list" replace />} />
                <Route
                  path="refund-list"
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <Refund />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.refund_list', { defaultValue: 'Refund List' }) }}
                />
                <Route
                  path="refund-details/:id"
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <RefundDetails />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.refund_details', { defaultValue: 'Refund Details' }) }}
                >

                  <Route
                    path="advance/:refund_id"
                    element={
                      <Suspense fallback={<DefaultLoader />}>
                        <AdvanceRefundDetails />
                      </Suspense>
                    }
                    handle={{ breadcrumb: tTopBar('breadcrum.advance') }}
                  />
                  <Route
                    path="invoice/:refund_id"
                    element={
                      <Suspense fallback={<DefaultLoader />}>
                        <InvoiceRefundDetails />
                      </Suspense>
                    }
                    handle={{ breadcrumb: tTopBar('breadcrum.invoice') }}
                  />
                </Route>
                <Route
                  path="patient-refund/:id"
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PatientRefund />
                    </Suspense>
                  }
                />
              </Route>

            
              <Route
                path='package-details/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PakageDetails />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.package') }}
              />
            </Route>
            
            {/* Inventory Routes */}
            <Route
              path = 'inventory'
              handle={{ breadcrumb: tTopBar('breadcrum.inventory') }}
            >
              <Route index element={<Navigate to="item-management" replace />} />
              <Route
                path="item-management"
                handle={{ breadcrumb: tTopBar('breadcrum.item_management') }}
                element={
                  <Suspense fallback={<InventoryLoader />}>
                    <StockContainer />
                  </Suspense>
                }
              >
                <Route index element={<Navigate to="stock" replace />} />
                <Route
                  path="stock"
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <AvailableStock />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.stock') }}
                />

                {/* 📘 Material Consumption page */}
                <Route
                  path="material-consumption"
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <MaterialConsumptionLog />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.material_consumption') }}
                />
              </Route>



              {/* .............................................................. */}

              {/* New Stock Transfer Routes */}
              <Route
                path='stock-transfer'
                handle={{ breadcrumb: tTopBar('breadcrum.stock_transfer') }}
                element={
                  <Suspense fallback={<InventoryLoader />}>
                    <StockTransferContainer />
                  </Suspense>
                }
              >
                <Route
                  index
                  element={<Navigate to="indent" replace />}
                />
                <Route
                  path='indent'
                  handle={{ breadcrumb: tTopBar('breadcrum.indent') }}
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <IdentListPage />
                    </Suspense>
                  }
                >
                  {/* <Route
                    path='new'
                    handle={{ breadcrumb: 'New' }}
                    element={
                      <Suspense fallback={<DefaultLoader />}>
                        <NewIndentPage />
                      </Suspense>
                    }
                  /> */}
                </Route>
                <Route
                  path="issue"
                  handle={{ breadcrumb: tTopBar('breadcrum.issue') }}
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <IssueListPage />
                    </Suspense>
                  }
                >
                  {/* <Route
                    path='new'
                    handle={{ breadcrumb: 'New' }}
                    element={
                      <Suspense fallback={<DefaultLoader />}>
                        <NewIssuePage />
                      </Suspense>
                    }
                  /> */}
                </Route>
                <Route
                  path="received"
                  handle={{ breadcrumb: tTopBar('breadcrum.received') }}
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <ReceiveListPage />
                    </Suspense>
                  }
                >
                </Route>
              </Route>
              {/* Purchase Requisition Routes */}
              <Route
                path='purchase'
                handle={{ breadcrumb: tTopBar('breadcrum.purchase') }}
                element={
                  <Suspense fallback={<InventoryLoader />}>
                    <PurchaseViewPage />
                  </Suspense>
                }
              >
                <Route
                  index
                  element={<Navigate to='requisition' replace/>}
                />
                <Route
                  path='requisition'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <RequisitionViewPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.requisition') }}
                >
                  <Route
                    path='new'
                    element={
                      <Suspense fallback={<InventoryLoader />}>
                        <NewRequisition />
                      </Suspense>
                    }
                    handle={{ breadcrumb: tTopBar('breadcrum.new_purchase_requisition') }}
                  />
                  <Route
                    path='edit/:pr_id'
                    element={
                      <Suspense fallback={<InventoryLoader />}>
                        <EditRequisition />
                      </Suspense>
                    }
                    handle={{ breadcrumb: tTopBar('breadcrum.edit_purchase_requisition') }}
                  />
                </Route>
                <Route
                  path='order'
                  handle={{breadcrumb: tTopBar('breadcrum.purchase_order')}}
                  element={<Navigate to="order/prospective" replace />}
                >
                  <Route index element={<Navigate to="prospective" replace />} />
                  <Route
                    path='prospective'
                    element={
                      <Suspense fallback={<InventoryLoader />}>
                        <PurchaseOrderPerspectiveList />
                      </Suspense>
                    }
                  />
                  <Route
                    path='ordered'
                    element={
                      <Suspense fallback={<InventoryLoader />}>
                        <PurchaseOrderOrderedList />
                      </Suspense>
                    }
                  />
                  <Route
                    path='new'
                    handle={{ breadcrumb: tTopBar('breadcrum.new_purchase_order') }}
                    element={
                      <Suspense fallback={<InventoryLoader />}>
                        <NewPurchaseOrder />
                      </Suspense>
                    }
                  />
                  <Route
                    path='edit/:po_id'
                    handle={{ breadcrumb: tTopBar('breadcrum.edit_purchase_order') }}
                    element={
                      <Suspense fallback={<InventoryLoader />}>
                        <EditPurchaseOrder />
                      </Suspense>
                    }
                  />
                  <Route
                    path='view/:po_id'
                    handle={{ breadcrumb: tTopBar('breadcrum.view_purchase_order') }}
                    element={
                      <Suspense fallback={<InventoryLoader />}>
                        <ViewPurchaseOrder />
                      </Suspense>
                    }
                  />
                </Route>
              </Route>

              {/* Stock Adjustment Routes */}
              <Route
                path='adjustment'
                handle={{ breadcrumb: tTopBar('breadcrum.adjustment') }}
                element={
                  <Suspense fallback={<InventoryLoader />}>
                    <StockAdjustmentContainer />
                  </Suspense>
                }
              >
                <Route index element={<Navigate to="quantity" replace />} />
                <Route
                  path='quantity/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <QuantityAdjustmentIndex />
                    </Suspense>
                  }
                />
                <Route
                  path='cost-mrp/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <CostAdjustmentListPage />
                    </Suspense>
                  }
                />
                <Route
                  path='batch-expiry/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <BatchExpiryAdjustmentIndex />
                    </Suspense>
                  }
                />
              </Route>
                    
              {/* grn Routes */}
              <Route
                path="grn"
                handle={{ breadcrumb: tTopBar('breadcrum.grn') }}
                element={
                  <Suspense fallback={<InventoryLoader />}>
                    <GRNContainer />
                  </Suspense>
                }
              >
                <Route index element={<Navigate to="prospective" replace />} />
                <Route
                  path="prospective"
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <GrnProspective />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.prospective') }}
                />

                {/* received */}
                <Route
                  path="received"
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <GrnReceived />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.received') }}
                />
              </Route>


              {/*GRN View Routes  */}
              <Route
                path='return'
                handle={{ breadcrumb: tTopBar('breadcrum.return') }}
              >
                <Route
                  index
                  element={<Navigate to='grn' replace/>}
                />
                <Route
                  path='grn/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <ReturnViewPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.grn') }}
                >
                </Route>
                <Route
                  path='issue/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <ReturnViewPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.issue') }}
                >
                </Route>
                <Route
                  path='receive/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <ReturnViewPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.receive') }}
                ></Route>
                <Route
                  path='expired/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <ReturnViewPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.expired') }}
                ></Route>

                <Route
                  path='sales/newsalesreturn/:id'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <NewSalesReturnPage />
                    </Suspense>
                  }
                />
                <Route
                  path='sales/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <ReturnViewPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.sales') }}
                />
                <Route
                  path='patient-sales/:id'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <PatientSalesReturnList />
                    </Suspense>
                  }
                />
                <Route
                  path='pharmacy/*'
                  element={
                    <Suspense fallback={<InventoryLoader />}>
                      <ReturnViewPage />
                    </Suspense>
                  }
                  handle={{ breadcrumb: 'Pharmacy' }}
                >
                  <Route
                    path='pharmacy-details/:id'
                    element={
                      <Suspense fallback={<InventoryLoader />}>
                        <NewPatientInvoice />  
                      </Suspense>
                    }
                    handle={{ breadcrumb: 'Pharmacy Details' }}
                  />
                </Route>
              </Route>
            </Route>
          </Route >
          <Route
            path='clinical'
            handle={{ breadcrumb: tTopBar('breadcrum.clinical') }}
          >
            <Route index element={<Navigate to='dashboard/' replace />} />
          
            <Route path='dashboard' handle={{ breadcrumb: tTopBar('breadcrum.dashboard') }} 
              element={
                <Suspense fallback={<DefaultLoader />}>
                  <ClinicalDashboard />
                </Suspense>
              }
            />
      
            <Route
              path='patients'
              handle={{ breadcrumb: tTopBar('breadcrum.patients') }}
            >
              <Route
                index
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <ClinicalPatientList />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
              <Route
                path='Summary/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <Summary />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.summary') }}
              />
              <Route
                path='medical-history/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <MedicalHistory />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.medical_history') }}
              />

              <Route
                path='examination/:id'
                element={
                  <Suspense >
                    <Examination />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.examination') }}
              />

              <Route
                path='hpi/:id'
                element={
                  <Suspense >
                    <HPI />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.hpi') }}
              />
              <Route
                path='investigation/:id'
                element={
                  <Suspense >
                    <InvestigationDiag />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.investigation') }}
              />
              <Route
                path='stimulation/:id'
                element={
                  <Suspense >
                    <StimPage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.stimulation') }}
              />
              <Route
                path='cycle-overview/:id'
                element={
                  <Suspense >
                    <CycleOverview />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.cycle_overview') }}
              />

              <Route
                path='treatment-plan/:id'
                element={
                  <Suspense >
                    <TreatmentPlanPage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.treatment_plan') }}
              />

              <Route
                path='surgery/:id'
                element={
                  <Suspense >
                    <SurgeryPage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.surgery') }}
              />
              <Route
                path='outcome/:id'
                element={
                  <Suspense >
                    <OutcomePage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.outcome') }}
              />

              <Route
                path='document/:id'
                element={
                  <Suspense >
                    <Documents />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.document') }}
              />
            </Route>
          </Route>
          {/* Add more routes here */}

          {/* Lab Routes */}

          <Route
            path='lab'
            handle={{ breadcrumb: tTopBar('breadcrum.lab') }}>
            <Route index element={<Navigate to='embryology/' replace />} />
            <Route
              path='embryology'
              handle={{ breadcrumb: tTopBar('breadcrum.embryology') }}>
              <Route
                index
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryoPatientList/>
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
              <Route
                path='oocyte-grading/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <OocyteGrading />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.oocyte_grading') }}
              />

              <Route
                path='embryo-culture/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <GradingHistoryProvider>
                      <EmbryoCulture />
                    </GradingHistoryProvider>                
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.embryo_culture') }}
              />

              <Route
                path='ai-embryo/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <GradingHistoryProvider>
                      <AimbryoDetails />
                    </GradingHistoryProvider>
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.ai_embryo') }}
              />
            


              <Route
                path='pgta/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PgtHome />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.pgt') }}
              />
              <Route
                path='pgta2/:id' 
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PgtHome2 />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.pgt') }}
              />
              <Route
                path='pgta/result'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PgtHome />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.pgt') }}
              />

              <Route
                path='cryo-thawing/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <CryoThawing />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.cryo_thawing') }}
              />
            </Route>
            <Route
              path='andrology'
              handle={{ breadcrumb: tTopBar('breadcrum.andrology') }}
            >
              <Route
                index
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <Andrology />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
              <Route
                path='semen-analysis/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <SemenAnalysisDetails />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.semen_analysis') }}
              />
              <Route
                path='semen-analysis/collection-details/:id/:analysisId'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <Collectiondetails />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.collection_details') }}
              />
              <Route
                path='semen-processing/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <SemenProcessing />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.semen_processing') }}
              />
              <Route
                path='semen-freezing/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <SemenFreezing />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.semen_freezing') }}
              />
              <Route
                path='semen-thawing/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <SemenThawing />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.semen_thawing') }}
              />
              <Route
                path='IUI/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <SemenIUI />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.iui') }}
              />
            </Route>


            <Route
              path='RFID'
              handle={{ breadcrumb: tTopBar('breadcrum.Audity') }}>
              <Route index element={<Navigate to='dashboard' replace />} />
              <Route
                path='patient-list'
                element={
                  <Suspense fallback={<DefaultLoader />}>               
                    <RFIDMainComponent />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.patient_list') }}
              />
              <Route
                path='dashboard'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <RFIDDashboard />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.dashboard') }}
              />
            </Route>















            <Route
              path='dashboard'
              element={
                <Suspense fallback={<DefaultLoader />}>
                  <LabDashboard />
                </Suspense>
              }
              handle={{ breadcrumb: tTopBar('breadcrum.dashboard') }}
            />
            <Route
              path='cryostorage'
              handle={{ breadcrumb: tTopBar('breadcrum.cryostorage') }}
            >
              <Route
                index
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <OocyteCryoStrorage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.oocyte') }}
              />
              <Route
                path='oocyte'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <OocyteCryoStrorage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.oocyte') }}
              />
              <Route
                path='embryo'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryoStorage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.embryo') }}
              />
              <Route
                path='sperm'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <SpermStorage />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.sperm') }}
              />
            </Route>
          </Route>

          {/* Settings Routes */}

          <Route
            path='ai'
            handle={{ breadcrumb: 'AI' }}
            element={
              <GradingHistoryProvider>
                <Outlet />
              </GradingHistoryProvider>
            }
          >
            <Route index element={<Navigate to='configuration/' replace />} />
          
            {/* <Route
              path='aiEmbryoGrader'
              handle={{ breadcrumb: tTopBar('breadcrum.AIEmbryoGrader') }}
              element={
                <Suspense fallback={<DefaultLoader />}>
                  <EmbryoGradingAI />
                </Suspense>
              }
            /> commented by Tejas on 25-10-2025 for AI Hub changes */}   
            {/* AI Hub  */}
            <Route
              path='aiHub'
              handle={{ breadcrumb: 'AI Hub' }}
              element={
                <Suspense fallback={<DefaultLoader />}>
                  <Outlet />
                </Suspense>
              }
            >
              {/* index route renders the AI Hub landing page */}
              <Route
                index
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryoGradingAIHub />
                  </Suspense>
                }
              />
              {/* nested AI lead chatbot route: shows lead patient list */}
              <Route
                path='aileadchatbot'
                handle={{ breadcrumb: tTopBar('breadcrum.AILeadChatbot') }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <AILeadChatbotPatientList />
                  </Suspense>
                }
              />
              {/* nested AI lead chatbot route: shows lead patient list */}
              <Route
                path='aiassistant'
                handle={{ breadcrumb: tTopBar('breadcrum.ClinicalDecisionSupport') }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <AIAssistant />
                  </Suspense>
                }
              />
              {/* optional chat sub-route if needed later */}
              <Route
                path='aileadchatbot/chat'
                handle={{ breadcrumb: tTopBar('breadcrum.AILeadChatbot') }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryoGradeAssistantPage />
                  </Suspense>
                }
              />
              {/* nested AI embryo grader patient list route: /ai/aiHub/embryograderlist */}
              <Route
                path='embryograderlist'
                handle={{ breadcrumb: tTopBar('breadcrum.AIEmbryoGrader') }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryoGraderPatientListComponent />
                  </Suspense>
                }
              />

              {/* nested AI lead chatbot route: shows lead patient list */}
              <Route
                path='aiassistant'
                handle={{ breadcrumb: tTopBar('Clinical Decision Support') }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <AIAssistant />
                  </Suspense>
                }
              />

              {/* Embryology Assistant route */}
              <Route
                path='embryologycopilot'
                handle={{ breadcrumb: 'Embryology Assistant' }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryologyCopilot />
                  </Suspense>
                }
              />
              {/* Finance Assistant route */}
              <Route
                path='financebot'
                handle={{ breadcrumb: 'Finance Assistant' }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <FinanceBot />
                  </Suspense>
                }
              />

              <Route
                path='embryograder'
                handle={{ breadcrumb: tTopBar('breadcrum.AIEmbryoGrader') }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryoGradingAI />
                  </Suspense>
                }
              />
              {/* AI Voice Data Entry as a parent with nested routes so breadcrumbs include it */}
              <Route
                path='voicedataentry'
                handle={{ breadcrumb: 'AI Voice Data Entry' }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <Outlet />
                  </Suspense>
                }
              >
                <Route
                  index
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <AiVoiceDataEntry />
                    </Suspense>
                  }
                />
                <Route
                  path='chat'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <AIVoiceChatBot />
                    </Suspense>
                  }
                />
                <Route
                  path='chat/extraction-review'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <AIVoiceExtractionReview />
                    </Suspense>
                  }
                />
                <Route
                  path='chat/extraction-result'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <AIVoiceExtractionResult />
                    </Suspense>
                  }
                />
              </Route>

              <Route
                path='documentintelligence'
                handle={{ breadcrumb: 'Document Intelligence' }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <Outlet />
                  </Suspense>
                }
              >
                <Route
                  index
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <DocumentIntPatientList />
                    </Suspense>
                  }
                />
                <Route
                  path='chat/:patientId'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <DocumentIntelligencePatientDetail />
                    </Suspense>
                  }
                />
              </Route>
              {/* nested AI live birth prediction route: /ai/aiHub/livebirthprediction */}
              <Route
                path='livebirthprediction'
                handle={{ breadcrumb: tTopBar('breadcrum.AILiveBirthPrediction') }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryoGradeLivebirthprediction />
                  </Suspense>
                }
              />
              <Route
                path='livebirthprediction/:patientId'
                handle={{ breadcrumb: tTopBar('breadcrum.AILiveBirthPrediction') }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <EmbryoGradeLivebirthpredictionDetail />
                  </Suspense>
                }
              />
              {/* AI Assistant route */}
              <Route
                path='aiassistant'
                handle={{ breadcrumb: 'AI Assistant' }}
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <AIAssistant />
                  </Suspense>
                }
              />
            </Route>
            <Route
              path='Voicedataentry'
              handle={{ breadcrumb: 'AI Voice Data Entry' }}
              element={
                <Suspense fallback={<DefaultLoader />}>
                  <AIVoiceChatBot />
                </Suspense>
              }
            />
            <Route
              path='reports'
              handle={{ breadcrumb: tTopBar('breadcrum.reports') }}
            >
              <Route
                path='clinical'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <AdminReports />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.clinical') }}
              />
              <Route
                path='clinical/template1'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <ReportTable />
                  </Suspense>
                }
                //That changes done only for demo purpose, later we can change it to dynamic breadcrumb based on report name
                handle={{ breadcrumb: tTopBar('MIS Report') }}
              />
            </Route>
            <Route
              path='configuration'
              handle={{ breadcrumb: tTopBar('breadcrum.configuration') }}
            >
              <Route index element={<Navigate to='user' replace />} />
              
              <Route
                path='user'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <UserConfig/>
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.user') }}
              />
              <Route
                path='userDetails'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <AddUser/>
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.user_details') }}
              />
              <Route
                path='consent'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <ConsentConfigContainer />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.consent') }}
              />
              <Route
                path='consent/new'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <ConsentAddEdit />
                  </Suspense>
                }
              />
              <Route
                path='consent/consent-edit/:consentId'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <ConsentAddEdit />
                  </Suspense>
                }
              />
              <Route
                path='clinic'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <ClinicConfig />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.clinic') }}
              />
              <Route
                path='clinic/:id'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <ClinicAddEditInfoForm />
                  </Suspense>
                }
              />
              <Route
                path='page'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PageConfig />
                  </Suspense>
                }
                handle={{ breadcrumb: tTopBar('breadcrum.page_configuration') }}
              />
              <Route
                path='package-configuration'
                handle={{ breadcrumb: tTopBar('breadcrum.package_configuration', { defaultValue: 'Package Configuration' }) }}
              >
                <Route index element={<Navigate to='package' replace />} />
                <Route
                  path='package'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PackageList />
                    </Suspense>
                  }
                />
                <Route
                  path='details'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <PackageConfigDetails />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.package_details', { defaultValue: 'Package Details' }) }}
                />
                <Route
                  path='package-Definition'
                  element={
                    <Navigate to='/ai/configuration/package-configuration/details' replace />
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.package_definition', { defaultValue: 'Package Definition' }) }}
                />


              </Route>

              <Route
                path='inventory-approval'
                handle={{ breadcrumb: tTopBar('breadcrum.inventory_approval') }}
              >
                <Route
                  index
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <InventoryApprovalList />
                    </Suspense>
                  }
                />
                <Route
                  path='create'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <CreateApprovalRule />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.create_rule') }}
                />
                <Route
                  path=':ruleId/view'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <ViewApprovalRule />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.view_rule') }}
                />
                <Route
                  path=':ruleId/edit'
                  element={
                    <Suspense fallback={<DefaultLoader />}>
                      <CreateApprovalRule />
                    </Suspense>
                  }
                  handle={{ breadcrumb: tTopBar('breadcrum.edit_rule') }}
                />
              </Route>
            </Route>
            <Route
              path='kpi_dashboard'
              element={
                <Suspense fallback={<DefaultLoader />}>
                  <KPIDashboard />
                </Suspense>
              }
              handle={{ breadcrumb: tTopBar('breadcrum.kpi_dashboard') }}
            >
              <Route
                path='bar_chart'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <Barchart />
                  </Suspense>
                }
              />
              <Route
                path='pie_chart'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <Piechart />
                  </Suspense>
                }
              />
              <Route
                path='polar_area_chart'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <PolarAreaChart />
                  </Suspense>
                }
              />
              <Route
                path='line_chart'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <LineChart />
                  </Suspense>
                }
              />
              <Route
                path='radar_chart'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <RadarChart />
                  </Suspense>
                }
              />
              <Route
                path='donut_chart'
                element={
                  <Suspense fallback={<DefaultLoader />}>
                    <DonutChart />
                  </Suspense>
                }
              />
            </Route>

          </Route>
          <Route path="redirect_login" element={<RedirectLogin />} />
          
          <Route path="*" element={<NotFoundPage />} />

        </Route>
      </>
    )
  );
  return <RouterProvider router={router} />;
}

export default AppRouterWithI18n;
